/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentWeb {
    constructor(cscom) {
        if (!(this instanceof CurrentWeb)) {
            return new CurrentWeb(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/web/view', null, data);
    }
}
